import React from 'react'
import clsx from 'clsx'
import Button from 'components/Button'
import Typography from 'components/Typography'
import InstagramOutlineIcon from 'components/Icon/InstagramOutlineIcon'
import TwitterIcon from 'components/Icon/TwitterIcon'
import DiscordIcon from 'components/Icon/DiscordIcon'
import EnvelopeIcon from 'components/Icon/EnvelopeIcon'
import LinkIcon from 'components/Icon/LinkIcon'

import stylesGlobal from 'stylesGlobal.module.scss'

const SocialList: React.FC<{
  align?: 'left' | 'center' | 'right'
  className?: string
  discord?: string
  email?: string
  instagram?: string
  twitter?: string
  title?: string
  url?: string
}> = ({ align = 'left', className, discord, email, instagram, title, twitter, url }) => {
  const hasContactCreator = url || discord || email || twitter || instagram

  if (!hasContactCreator) return null

  return (
    <div className={className}>
      {title ? (
        <Typography
          variant="body1"
          component="div"
          className={clsx(stylesGlobal.MarginBottom8, stylesGlobal.WhitespaceNoWrap)}
          textAlign={align}
        >
          {title}
        </Typography>
      ) : null}

      <ul
        className={clsx(
          stylesGlobal.DisplayFlex,
          stylesGlobal.ListNone,
          stylesGlobal.Padding0,
          stylesGlobal.Margin0,
          align === 'center' && stylesGlobal.JustifyContentCenter,
          align === 'right' && stylesGlobal.JustifyContentFlexEnd
        )}
      >
        {url ? (
          <li>
            <Button color="primary" href={url} target="_blank" tooltip="Website" icon>
              <LinkIcon />
            </Button>
          </li>
        ) : undefined}

        {email ? (
          <li>
            <Button color="primary" href={`mailto:${email}`} target="_blank" tooltip="Email" icon>
              <EnvelopeIcon />
            </Button>
          </li>
        ) : undefined}

        {discord ? (
          <li>
            <Button color="primary" href={discord} target="_blank" tooltip="Discord" icon>
              <DiscordIcon />
            </Button>
          </li>
        ) : undefined}

        {twitter ? (
          <li>
            <Button color="primary" href={twitter} target="_blank" tooltip="Twitter" icon>
              <TwitterIcon />
            </Button>
          </li>
        ) : undefined}

        {instagram ? (
          <li>
            <Button color="primary" href={instagram} target="_blank" tooltip="Instagram" icon>
              <InstagramOutlineIcon />
            </Button>
          </li>
        ) : undefined}
      </ul>
    </div>
  )
}

export default SocialList
